module.exports = __webpack_public_path__ + "static/team_nachiket-55a4529672f393369cf1c4ad9d397a07.jpg";